import React, { useEffect } from "react";

const DisableZoom = () => {
	useEffect(() => {
		const handleWheel = (e) => {
			if (e.ctrlKey) {
				e.preventDefault(); // Prevent zooming with Ctrl key
			}
		};

		const handleKeydown = (e) => {
			if (e.ctrlKey && (e.key === "Plus" || e.key === "-" || e.key === "+")) {
				e.preventDefault(); // Prevent zooming with Ctrl + Plus/Minus
			}
		};

		window.addEventListener("wheel", handleWheel, { passive: false });
		window.addEventListener("keydown", handleKeydown, { passive: false });

		return () => {
			window.removeEventListener("wheel", handleWheel);
			window.removeEventListener("keydown", handleKeydown);
		};
	}, []);

	return <div className="d-none">Your React Component Content</div>;
};

export default DisableZoom;
